<template>
  <div class="alertcontent" v-if="show" @click.self="show=false">
    <div class="alertcontentdiv">
      <div class="alertcontentdiv_head">
        <p>{{dlgTitle}}</p>
        <div>
          <i class="el-icon-close" @click="close"></i>
        </div>
      </div>
      <div class="alertcontentdiv_params">
        <div class="alertcontentdiv_params_filiale" v-if="filialeOpen">
          <label style="display:inline;margin-right:10px">送货分公司:</label>
          <el-select v-model="filialeValue" placeholder="请选择" clearable filterable   @change = changeGataDate>
            <i slot="prefix" class="el-input__icon el-icon-search" style="line-height: 22px !important;"></i>
            <el-option
              v-for="item in filialeOptions"
              :key="item.vkorg"
              :label="item.vkorg + ' ' +item.vremark"
              :value="item.vkorg">
            </el-option>
        </el-select>
        </div>
        <div>
          <label style="display:inline;margin-right:10px">{{searchTitle}}</label>
          <el-input v-model="name" :placeholder="placeholder"  style="width:200px"></el-input>
        </div>
        <el-button size="mini" type="primary" icon="el-icon-search" style="padding: 5px 10px" @click="searchData(false)">搜索</el-button>
      </div>
      <!-- <div class="searchbutton">
          <el-button size="mini" type="primary" icon="el-icon-search" @click="searchData">搜索</el-button>
      </div> -->
      <div class="alertcontentdiv_table">
        	<el-table ref="multipleTable" :data="dataList"
            :highlight-current-row="true" :row-class-name="tableRowClassName"
             @row-click="rowClick" tooltip-effect="dark" style="width: 100%"  border height=100%>
            <div  slot="empty" v-if="emptyErrorText" :class="loading?'':'empty-err'">{{loading?'暂无数据':emptyErrorText}}</div>
                <el-table-column  v-if="selectType === 0" label="" width="50" fixed align="center">
                    <template slot-scope="props">
                        <span class="tran_box">
                           <el-radio v-model="selectId" :label="props.row[idField]">&nbsp;</el-radio>
                       </span>
                    </template>
           </el-table-column>
                <el-table-column  v-else-if="selectType === 1" label="" width="50" fixed align="center">
                    <template slot-scope="scope">
                       <span class="tran_box">
                   <el-radio v-model="selectIndex" :label=" scope.$index">&nbsp;</el-radio>
                 </span>
                    </template>
                  </el-table-column>
                <el-table-column label="序号" width="50" center align="center">
                    <template slot-scope="scope">{{ scope.$index+1+(pageNo-1)*pageSize }}</template>
                </el-table-column>

                <el-table-column v-for="(item,index) in columns" :key="index" header-align="center" :width="item.width" :prop="item.name" :label="item.label" show-overflow-tooltip :align="item.align || 'center'">
                    <template slot-scope="scope">{{item.formatter ? item.formatter(scope.row[item.name], scope.row, index) : scope.row[item.name]}}</template>
                </el-table-column>
            </el-table>
      </div>
      <div class="alertcontentdiv_page">
          <div>
            总共<font style="color:#409EFF">{{totalRows}}</font>条记录
          </div>
          <el-pagination layout="prev, pager, next" :total="totalRows"  :current-page="pageNo" :page-size="pageSize" @current-change="currentChangeType">
          </el-pagination>
      </div>
      <div class="alertcontentdiv_buttom">
        <el-button size="mini" @click="close">关闭</el-button>
        <el-button size="mini" type="primary" @click="confirm">确认</el-button>
      </div>
    </div>
  </div>
</template>
<script>
// import * as Api from '@/api/promotion.js'
import { methodPost } from '../../api/request'
import dynamicColumnsMixin from '@/mixins/dynamicColumns.js';

function requried(column) {
  throw new Error(`缺少参数[${column}]`)
}

export default {
  name: 'SearchDialog',
  components: {},
  mixins: [dynamicColumnsMixin],
  data() {
    return {
      show: false,
      loading: false,
      dlgTitle: '',
      placeholder: '',
      searchTitle: '',
      selectId: '', // 选中的id
      selectIndex: -1,
      selectedItem: {},
      pageNo: 1, // 当前页码
      pageSize: 20, // 每页多少条数据
      totalRows: 0, // 总共多少数据
      columns: [],
      dataList: [ // 数据源
      ],
      emptyErrorText: '',
      name: '',
      filialeOptions: [
      ],
      filialeValue: '',
      filialeurl: '', // 分公司url,
      filialeOpen: false // 是否需要分公司下拉框
    }
  },
  created() {
  },
  methods: {
    async open({
      dlgTitle,
      url = requried('url'),

      selectId,
      selectType = 0,
      emptyErrorText = '',
      searchFieldName = 'customerName',
      additionalParams,
      emptyMessage = requried('emptyMessage'),
      pageNo = 1,
      pageSize = 20,
      tableColumns = requried('tableColumns'),
      idField = 'id',
      filialeSelect = {},
      searchTitle = '开单客户:',
      placeholder
    }) {
      this.show = true;
      this.dlgTitle = dlgTitle;
      this.searchTitle = searchTitle
      this.url = url;
      this.emptyErrorText = emptyErrorText
      this.selectId = selectId;
      this.additionalParams = additionalParams;
      this.emptyMessage = emptyMessage;
      this.selectType = selectType;
      this.searchFieldName = searchFieldName;
      this.pageNo = pageNo;
      this.pageSize = pageSize;
      this.columns = tableColumns;
      this.idField = idField;
      this.placeholder = placeholder;
      this.filialeurl = filialeSelect.filialeurl;
      this.filialeOpen = filialeSelect.filialeOpen;
      const params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize
      }
      if (this.filialeOpen) {
        const { data } = await this.getDataFiliale()
        this.filialeOptions = data
        this.filialeValue = ''
        params.wwDcompanyCode = ''
      }
      return new Promise((resolve, reject) => {
        this.getData(params).then(() => {
          if (this.selectType === 1) {
            this.selectIndex = -1
            const index = this.dataList.findIndex(o => {
              return o[this.idField] === this.selectId
            })
            this.selectedItem = (index >= 0) ? this.dataList[index] : {};
            this.selectIndex = index
          } else {
            this.selectedItem = this.dataList.find(o => o[this.idField] === this.selectId) || {};
          }
          this.resolve = resolve;
          this.reject = reject;
        })
      })
    },
    tableRowClassName({ row, rowIndex }) {
      row['$index'] = rowIndex;
    },
    getData(params) {
      this.loading = true
      return methodPost(this.url, {
        ...params,
        ...this.additionalParams
      }).then(res => {
        this.loading = false
        const { code, data, message } = res
        if (code !== 0) {
          this.$message(message)
        } else {
          if (data.data.length > 0) {
            this.dataList = data.data.map(o => {
              const item = {
                ...o
              }
              this.columns.forEach((c, index) => {
                if (c.translater) {
                  item[c.name] = c.translater(item[c.name], item, index)
                }
              })
              return item;
            })
            this.computerColumnWidth(data.data)
            this.totalRows = data.totalRows
          } else {
            this.dataList = []
            this.totalRows = 0
          }
        }
      })
    },
    getDataFiliale() {
      return new Promise((resolve, reject) => {
        try {
          methodPost(this.filialeurl, { noLoading: true, pageSize: 1000 }).then(res => {
            if (res.code === 0 && res.subCode === 1) {
              console.error(res.data)
              resolve(res);
            } else {
              reject(new Error('网络错误'))
            }
          }).catch(_ => {
            reject(new Error('json parse error'));
          })
        } catch (e) {
          reject(e);
        }
      });
    },
    changeGataDate() {
      let params = {}
      this.pageNo = 1
      params = {
        [this.searchFieldName]: this.name,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        wwDcompanyCode: this.filialeValue
      }
      this.getData(params)
    },
    rowClick(row, column, cell, event) {
      this.selectId = row[this.idField];
      this.selectIndex = row['$index'] || -1
      this.selectedItem = row;
    },
    currentChangeType(pageNo) {
      this.pageNo = pageNo
      this.searchData(true)
    },
    confirm() {
      if (!this.selectedItem[this.idField]) {
        this.$message.error(this.emptyMessage)
      } else if (this.selectId) {
        this.selectedItem = this.dataList.find(o => o[this.idField] === this.selectId) || {};
        if (this.selectedItem[this.idField]) {
          this.resolve(this.selectedItem);
        } else {
          this.$message.error(this.emptyMessage)
        }
      } else {
        this.resolve(this.selectedItem);
      }
    },
    searchData(flag) {
      let params = {}
      this.pageNo = flag ? this.pageNo : 1
      params = {
        [this.searchFieldName]: this.name,
        pageNo: this.pageNo,
        pageSize: this.pageSize
      }
      if (this.filialeOpen) {
        params.wwDcompanyCode = this.filialeValue
      }
      this.getData(params)
    },
    close() {
      this.name = ''
      this.show = false;
      this.selectId = ''
    }
  }
}
</script>

<style type="text/scss" lang="scss" scoped>
  .empty-err{
    text-align: center;
    color: red
  }
.alertcontent {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  .alertcontentdiv {
    position: absolute;
    left: calc(50% + 90px);
    top: 50%;
    transform: translate(-50%, -50%);
    width: 900px;
    height: 660px;
    padding: 20px;
    // padding-top: 0;
    background: #fff;
    display: flex;
    flex-direction: column;
    .el-icon-close {
      font-size: 20px;
      cursor: pointer;
    }
    .alertcontentdiv_head {
      display: flex;
      align-items: center;
      position: relative;
      padding-bottom: 10px;
      border-bottom: 1px solid #ddd;
      p {
        height: 30px;
        line-height: 30px;
        font-size: 18px;
        font-weight: bold;
      }
      &>div {
        position: absolute;
        right: 10px;
      }
    }
    .searchbutton {
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
    .alertcontentdiv_params {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      height: 50px;
      margin-bottom: 10px;
      &>div {
        width: 280px;
        label {
          font-size: 14px;
          font-weight: normal;
        }
      }
      .alertcontentdiv_params_filiale {
        width: 350px;
        div {
          width: 200px;
        }
        & /deep/ .el-input--medium .el-input__icon {
          line-height: 28px !important;
        }
      }
    }
    .alertcontentdiv_table {
      flex:1;
      overflow-y: auto;
    }
    .alertcontentdiv_page {
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
      div:nth-of-type(1) {
        font-size: 14px;
      }
      .el-pagination {
        float: right;
      }
    }
    .alertcontentdiv_buttom {
      height: 32px;
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/_app/wwka/src/views/components/search-dialog.vue